module.exports = __webpack_public_path__ + "static/media/hdbgvd.30fe6f02.mp4";